function Report() {
  return (
    <div>
      <h2>Report</h2>
      <p>Your complete information comes here.</p>
    </div>
  );
}

export default Report;